import { Component, ViewChild, signal } from '@angular/core';
import { CrossComponentService } from '../../core/services/cross-component.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from "@angular/router";
import { IntlTelInputDirective, IntlTelInputOptions } from '../../core/directives/intl-tel-input.directive';
import { ContactsHttpService } from '../../core/services/contacts.http.service';
import { UserHttpService } from '../../core/services/user.http.service';


@Component({
  selector: 'app-call-modal',
  imports: [ReactiveFormsModule, RouterLink, IntlTelInputDirective],
  templateUrl: './call-modal.html',
  styleUrl: './call-modal.scss',
})
export class CallModal {

  /** Phone Input Options */
  itiOptions: IntlTelInputOptions = {
    initialCountry: 'us',
    countryOrder: ['us', 'gb'],
    separateDialCode: true,
    loadUtils: () => import('intl-tel-input/utils'),
  };

  @ViewChild(IntlTelInputDirective)
  telInput!: IntlTelInputDirective;

  callForm!: FormGroup;
  isSubmitting = signal(false);
  successMessage = signal('');
  errorMessage = signal('');

  constructor(
    private crossComponentService: CrossComponentService,
    private fb: FormBuilder,
    private contactsHttpService: ContactsHttpService,
    private userHttpService: UserHttpService
  ) {
    this.callForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: [undefined, Validators.required],
      company_name: [''],
      convenient_time: [undefined, Validators.required],
      message: [''],

    });

    this.prefillFormFromUser();
  }

  private prefillFormFromUser() {
    const user = this.userHttpService.currentUser();
    if (!user) return;

    this.callForm.patchValue({
      name: user.full_name || '',
      email: user.email || '',
      phone: user.phone || '',
      company_name: user.company_name || '',
    });

    if (!user._id) return;

    this.userHttpService.getProfile(user._id).subscribe({
      next: (res: any) => {
        const profile = res?.profile || {};
        this.callForm.patchValue({
          name: profile.full_name || this.callForm.value.name || '',
          email: profile.email || this.callForm.value.email || '',
          phone: profile.phone || this.callForm.value.phone || '',
          company_name: profile.company_name || this.callForm.value.company_name || '',
        });
      },
    });
  }

  closeModal() {
    this.crossComponentService.closeCallModal();
  }

  onSubmit() {
    if (this.callForm.invalid) {
      this.callForm.markAllAsTouched();
      return
    }

    this.isSubmitting.set(true);
    this.successMessage.set('');
    this.errorMessage.set('');

    const formValue = this.callForm.value;
    const phone = this.telInput?.getInternationalNumber() || formValue.phone || '';

    this.contactsHttpService.requestPhoneCall({
      name: formValue.name,
      company_name: formValue.company_name || '',
      email: formValue.email,
      phone,
      convenient_time: this.formatConvenientTime(formValue.convenient_time),
      message: formValue.message || '',
    }).subscribe({
        next: (res: any) => {
          this.isSubmitting.set(false);
          this.successMessage.set(res?.message || 'Contact request sent successfully');
          this.callForm.reset();
        },
        error: (error) => {
          this.isSubmitting.set(false);
          this.errorMessage.set(error?.error?.message || 'Could not send your request. Please try again.');
        },
      });
  }

  private formatConvenientTime(time: string): string {
    if (!time) return '';

    const [hoursValue, minutes = '00'] = time.split(':');
    const hours = Number(hoursValue);

    if (Number.isNaN(hours)) return time;

    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;

    return `${displayHours}:${minutes} ${period}`;
  }
}
